import { render, staticRenderFns } from "./exploration.vue?vue&type=template&id=0dc83835&"
import script from "./exploration.vue?vue&type=script&lang=js&"
export * from "./exploration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports